import { FC } from 'react';
import { Box, Skeleton, Stack } from '@mui/material';
import { VyDivider } from '../../../../components/new-design/atoms';
import { AnalyticMetricV2, NavigationProps } from '../analytics/AnalyticMetric/AnalyticMetricV2.tsx';
import { VyPaper } from '../../../../components/new-design/data-display/VyPaper/VyPaper.tsx';
import { isNotNullOrUndefined } from '@vy/utils';
import { colors } from '../../../../assets/themes/colors';

export type KPIMetric = {
  name: string;
  value: number;
  prevValue?: number;
  formatter?: (value: number) => string;
  navigationProps?: NavigationProps;
  dataVy?: string;
};

type TopKPIMetricsProps = {
  metrics: KPIMetric[];
  isLoading?: boolean;
};

export const TopKPIMetrics: FC<TopKPIMetricsProps> = ({ metrics, isLoading = false }) => {
  return (
    <VyPaper
      sx={{
        padding: '16px 20px',
        borderRadius: '10px',
        boxShadow: 'none',
        border: `1px solid ${colors.grey[20]}`,
      }}
    >
      <Stack
        direction="row"
        divider={<VyDivider flexItem orientation="vertical" />}
        sx={{
          gap: 2.5,
          flexWrap: "wrap"
        }}>
        {isLoading ? (
          <Loader />
        ) : (
          metrics.map((metric) => (
            <Box key={metric.name} sx={{
              flexGrow: 1
            }}>
              <AnalyticMetricV2
                titleText={metric.name}
                value={metric.value}
                prevValue={metric.prevValue}
                formatter={metric.formatter}
                growthRateLabel={isNotNullOrUndefined(metric.prevValue) ? 'MoM' : undefined}
                navigationProps={metric.navigationProps}
                dataVy={metric.dataVy}
              />
            </Box>
          ))
        )}
      </Stack>
    </VyPaper>
  );
};

function Loader() {
  const SKELETON_ITEM_COUNT = 5;

  return Array.from({ length: SKELETON_ITEM_COUNT }).map((_, index) => (
    <Box
      key={index}
      sx={{
        flexGrow: 1,
        minWidth: 120
      }}>
      <Skeleton variant="text" width="60%" height={20} />
      <Skeleton variant="text" width="80%" height={40} />
      <Skeleton variant="text" width="45%" height={18} />
    </Box>
  ));
}
